import { Component } from '@angular/core';
import templateString from './requestDemoTemplate.html'
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { Title }     from '@angular/platform-browser';



@Component({
  selector: 'request-demo',
  template: templateString
})


export class RequestDemoComponent {
  constructor(private httpClient: HttpClient,
              private toastr: ToastrService,
              private titleService: Title){}


  runningRequest: boolean = false;
  // website is the honeypot field — hidden from humans, auto-filled by bots.
  demoRequest: object = {email: '', first_name:'', last_name:'', company_name:'', message: '', website: ''};

  ngOnInit(){
    this.titleService.setTitle( "TheoremReach - Request Access" );
    $("#scene").parallax();
  }

  requestDemo() {
    if (this.runningRequest == true){
      return false;
    }
    this.runningRequest = true;
    this.httpClient.post("/api/internal/demo_requests", this.demoRequest).subscribe(
      (response) => {
        this.runningRequest = false;
        this.demoRequest = {email: '', first_name:'', last_name:'', company_name:'', message: '', website: ''};
        this.toastr.success("Our team will reach out shortly to get you set up.", 'Request Received');
      },
      (error) => {

        this.toastr.error(error.error.error, 'Cannot Submit Request');
        this.runningRequest = false;
        }
      );
  }

}
